import { render, staticRenderFns } from "./annual-leave-remaining.vue?vue&type=template&id=480c5743&"
import script from "./annual-leave-remaining.vue?vue&type=script&lang=js&"
export * from "./annual-leave-remaining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports